<template>
  <div>
    <van-button type="primary" @click="clk(0)">公众责任险</van-button>
    <van-button type="info" @click="clk(1)">财产一切险</van-button>
    <van-button type="default" @click="clk(2)">工程保险</van-button>
    <van-button type="warning" @click="clk(3)">推荐保险</van-button>
    <van-button type="danger" @click="clk(4)">我的理赔</van-button>
    <van-button type="primary" @click="clk(5)">我的保单</van-button>
    <van-button type="info" @click="clk(6)">本店保险</van-button>
    <van-button type="info" @click="clk(7)">施工人员意外险</van-button>
    <van-button type="info" @click="clk(8)">经营期保险</van-button>
    <van-button type="info" @click="clk(9)">施工期保险</van-button>
    <van-button type="info" @click="clk(10)">服务商保险</van-button>
    <van-button type="info" @click="clk(11)">商户专属员工意外险</van-button>
  </div>
</template>

<script>
import { Button } from 'vant';
console.log(location);
const insure_auth = location.hash.includes('_dev') ? 'insure_auth_dev' : 'insure_auth'
const nemu = {
  0: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_public`,
  1: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_money`,
  2: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_project`,
  3: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_suggest`,
  4: `${location.origin}${location.pathname}#/${insure_auth}?pageType=myPay`,
  5: `${location.origin}${location.pathname}#/${insure_auth}?pageType=myBill`,
  6: `${location.origin}${location.pathname}#/${insure_auth}?pageType=myInsure`,
  7: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_anything`,
  8: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_operating`,
  9: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_building`,
  10: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_service`,
  11: `${location.origin}${location.pathname}#/${insure_auth}?pageType=insure_worker_owner`,
};
export default {
  components: {
    VanButton: Button,
  },
  methods: {
    clk(index) {
      window.location.href = nemu[index];
    },
  },
};
</script>

<style>
</style>